import React, { useCallback } from 'react';
import { Button, Intent } from '@blueprintjs/core';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../state/rootReducer';
import userFlowSlice from '../../features/userFlow/userFlowSlice';
import { useGetEnterpriseConfigQuery } from '../../apiHooks/enterpriseConfigApi';

export default function EnterpriseSsoButtons() {
    const dispatch = useDispatch();
    const isSignInLoading = useSelector((state: IRootState) => state.userFlow.enterpriseDeploymentSignInIsLoading);
    const { data: enterpriseConfig, isLoading: isConfigLoading } = useGetEnterpriseConfigQuery();
    const ssoConnections = enterpriseConfig?.sso_connections ?? [];
    const buttonIntent = ssoConnections.length === 1 ? Intent.SUCCESS : Intent.NONE;

    const handleSsoSignIn = useCallback(
        (ssoConnectionUuid: string) => {
            dispatch(userFlowSlice.actions.enterpriseDeploymentSignIn({ ssoConnectionUuid }));
        },
        [dispatch],
    );

    if (isConfigLoading) {
        return (
            <Button className='my-2' disabled={true} fill={true} intent={Intent.NONE} large={true}>
                Loading...
            </Button>
        );
    }

    if (ssoConnections.length === 0) {
        return <p className='text-center text-sm text-gray-600'>Failed to load SSO config. Please contact support.</p>;
    }

    return (
        <>
            {ssoConnections.map(({ display_name, uuid }) => (
                <Button
                    className='my-2'
                    fill={true}
                    intent={buttonIntent}
                    key={uuid}
                    large={true}
                    loading={isSignInLoading}
                    onClick={() => handleSsoSignIn(uuid)}
                >
                    {`Login with ${display_name} credentials`}
                </Button>
            ))}
        </>
    );
}
